export function getPaginationWindow({ itemCount, itemPerPage, pageNumber, reducedSidePages = false, }) {
    const safeItemPerPage = Math.max(1, Number(itemPerPage) || 1);
    const pageMax = Math.ceil(Number(itemCount) / safeItemPerPage);
    const firstOffset = reducedSidePages ? 1 : 2;
    const secondOffset = reducedSidePages ? 2 : 3;
    const firstPage = Math.max(1, Number(pageNumber) - firstOffset);
    const lastPage = Math.min(pageMax, Number(pageNumber) + secondOffset - 1);
    const pages = [];
    for (let page = firstPage; page <= lastPage; page++) {
        pages.push({
            pageNumber: page,
            isSelected: page === pageNumber ? 1 : 0,
        });
    }
    return { pageMax, pages };
}
